import { cn } from "@omni/utils/styles";
import { ReactNode, useState } from "react";
import { useSelector } from "react-redux";

import { FlyoutMenuContextProvider } from "@/components/General/FlyoutMenu/context/flyoutMenu.context";
import { ActiveCategoryIndexes } from "@/components/General/FlyoutMenu/types/activeCategoryIndexes.type";
import { Overlay } from "@/components/General/Overlay/overlay";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as FlyoutCategoriesSelectors from "@/redux/modules/value/flyoutCategories/flyoutCategories.selectors";
import * as HeaderModule from "@/redux/modules/value/header/header.module";
import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";

type Props = {
    children: ReactNode;
};

export const Base = ({ children }: Props) => {
    const [activeCategoryIndexes, setActiveCategoryIndexes] =
        useState<ActiveCategoryIndexes>([0, null, null, null]);

    const dispatch = useThunkDispatch();

    const open = useSelector(HeaderSelectors.isFlyoutActive);

    const rootCategory = useSelector(
        FlyoutCategoriesSelectors.getFlyoutCategories
    );

    const handleOnClose = () => {
        dispatch(
            HeaderModule.update({
                flyoutActive: false
            })
        );

        setActiveCategoryIndexes([0, null, null, null]);
    };

    if (!rootCategory) return null;

    return (
        <FlyoutMenuContextProvider
            rootCategory={rootCategory}
            activeCategoryIndexes={activeCategoryIndexes}
            setActiveCatetoryIndexes={setActiveCategoryIndexes}
            onClose={handleOnClose}
        >
            <Overlay
                open={open}
                onClose={handleOnClose}
                overlayHeader={false}
                scrollLock={true}
            >
                <Overlay.Content
                    className={cn("tw:page-container")}
                    positionAtMount={true}
                >
                    <div
                        className={cn(
                            "tw:w-full tw:bg-background tw:p-6 tw:mb-4 tw:h-[clamp(20dvh,40rem,calc(100vh-var(--header-height--desktop)))]"
                        )}
                    >
                        {children}
                    </div>
                </Overlay.Content>
            </Overlay>
        </FlyoutMenuContextProvider>
    );
};
